export default {
    CARD_WITHOUT_ASSIGNEES: 101,
    PROMISE_CANCELLED: 102,
};
